let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kBpIt")).then(() => parcelRequire('55jU9'));